import * as React from 'react';
import { cn } from '@/shared/lib/utils';

interface SceneCardProps {
    index: number;
    title?: string;
    isSelected?: boolean;
    onClick?: () => void;
    href?: string;
    className?: string;
}

export function SceneCard({
    index,
    title,
    isSelected,
    onClick,
    href,
    className
}: SceneCardProps) {
    const isNavigation = !!href;
    const displayText = title?.trim() || `Scene ${index}`;

    const cardClasses = cn(
        "group flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm transition-colors",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sidebar-ring",
        isSelected
            ? "bg-muted text-sidebar-accent-foreground font-medium"
            : "text-sidebar-foreground/80 hover:bg-sidebar-accent/50 hover:text-sidebar-foreground",
        className
    );

    const content = (
        <>
            <span className="shrink-0 text-sidebar-foreground/50 tabular-nums">
                {index}.
            </span>
            <span className="truncate" title={displayText}>
                {displayText}
            </span>
        </>
    );

    if (isNavigation) {
        return (
            <a href={href} className={cardClasses} onClick={onClick}>
                {content}
            </a>
        );
    }

    return (
        <button type="button" onClick={onClick} className={cardClasses}>
            {content}
        </button>
    );
}
